// Mock data for PHOS Studio website

export const services = [
  {
    id: 1,
    title: "Social Media Content & Ads",
    description: "Strategic content creation and paid ad creative that stops the scroll. We craft thumb-stopping visuals and copy that convert browsers into buyers.",
    features: [
      "Content strategy & planning",
      "Platform-optimized creative",
      "Ad creative testing & iteration",
      "Brand-aligned storytelling",
      "Performance tracking",
      "Social media management"
    ],
    icon: "Megaphone"
  },
  {
    id: 2,
    title: "Video & Content Editing",
    description: "Professional editing that transforms raw footage into scroll-stopping content. Tailored for social platforms, optimized for engagement.",
    features: [
      "Short-form video editing",
      "Long-form video editing",
      "Motion graphics & effects",
      "Color grading & audio mix",
      "Multi-platform optimization",
      "Fast turnaround times"
    ],
    icon: "Film"
  },
  {
    id: 3,
    title: "UGC Production",
    description: "Authentic, actor-driven content that builds trust and drives conversions. Real people, real stories, real results.",
    features: [
      "Professional actor network",
      "Scripting & direction",
      "Multi-actor campaigns",
      "Platform-native formats",
      "Rights-cleared content"
    ],
    icon: "Users"
  }
];

export const pricingPackages = {
  socialMedia: [
    {
      tier: "Tier 1 – Content + Ads Starter",
      price: "$1,750",
      period: "/month",
      description: "Essential setup for a single platform",
      features: [
        "6–8 videos",
        "4 static posts",
        "Basic ad testing",
        "1 platform"
      ],
      popular: false
    },
    {
      tier: "Tier 2 – Growth System",
      price: "$2,500",
      period: "/month",
      description: "Optimized creative testing across platforms",
      features: [
        "6–10 videos",
        "8 static posts",
        "Ad creative testing",
        "2–3 platforms",
        "CRM support",
        "Optimization"
      ],
      popular: true
    },
    {
      tier: "Tier 3 – Performance Engine",
      price: "$5,000+",
      period: "/month",
      description: "A/B ad testing & scaling creatives",
      features: [
        "8–12 videos",
        "12 static posts",
        "A/B ad testing",
        "Funnel thinking",
        "CRM support",
        "Scaling creatives"
      ],
      popular: false
    }
  ],
  editing: [
    {
      tier: "Tier 1 – Editing Only (Entry)",
      price: "$1,000",
      period: "/month",
      description: "Essential editing for short or long-form",
      features: [
        "8 short-form videos",
        "OR 2 long-form videos",
        "7 business day turnaround",
        "1 round of revisions"
      ],
      popular: false
    },
    {
      tier: "Tier 2 – Creator Package",
      price: "$1,500",
      period: "/month",
      description: "Balanced mix of long and short-form content",
      features: [
        "4 long-form videos",
        "8–12 short-form clips",
        "Faster turnaround",
        "2 rounds of revisions"
      ],
      popular: true
    },
    {
      tier: "Tier 3 – Custom Production",
      price: "Custom",
      period: "",
      description: "Fully customized editing packages tailored to your needs",
      features: [
        "Custom video deliverables",
        "Tailored to your content strategy",
        "Priority turnaround",
        "Unlimited revisions",
        "Dedicated editor"
      ],
      popular: false
    }
  ],
  ugc: [
    {
      tier: "Tier 1 – UGC Starter",
      price: "$1,200",
      period: "/month",
      description: "Filming & editing all included",
      features: [
        "3 videos",
        "Filming & editing included",
        "30 day turnaround",
        "2 rounds of revisions"
      ],
      popular: false
    },
    {
      tier: "Tier 2 – UGC Growth",
      price: "$2,000",
      period: "/month",
      description: "More videos with scripting support & ad funnels",
      features: [
        "6 videos",
        "5 business day turnaround",
        "3 revisions per video",
        "Scripting support",
        "Ad funnel strategy",
        "A/B test variations with different hooks"
      ],
      popular: true
    },
    {
      tier: "Tier 3 – Ad Creative System",
      price: "$3,000+",
      period: "",
      description: "Custom packages built for ads",
      features: [
        "Custom video packages",
        "Built for performance ads",
        "TikTok Shop support",
        "Multiple hooks & variations",
        "Full creative strategy"
      ],
      popular: false
    }
  ]
};

export const portfolioItems = [
  {
    id: 1,
    title: "E-commerce Product Launch",
    category: "Social Media Content & Ads",
    image: "https://images.pexels.com/photos/5393438/pexels-photo-5393438.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description: "Complete social media campaign for DTC brand launch"
  },
  {
    id: 2,
    title: "Brand Video Series",
    category: "Video & Content Editing",
    image: "https://images.unsplash.com/photo-1625690303837-654c9666d2d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHx2aWRlbyUyMHByb2R1Y3Rpb258ZW58MHx8fHwxNzc1NjYzODEzfDA&ixlib=rb-4.1.0&q=85",
    description: "Professional video editing for startup's content strategy"
  },
  {
    id: 3,
    title: "Creator Campaign",
    category: "UGC Production",
    image: "https://images.unsplash.com/photo-1632187989763-c9c620420b4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHx2aWRlbyUyMHByb2R1Y3Rpb258ZW58MHx8fHwxNzc1NjYzODEzfDA&ixlib=rb-4.1.0&q=85",
    description: "Multi-creator UGC campaign for wellness brand"
  },
  {
    id: 4,
    title: "Social Media Ads",
    category: "Social Media Content & Ads",
    image: "https://images.pexels.com/photos/4452602/pexels-photo-4452602.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description: "High-converting ad creative for Meta & TikTok"
  },
  {
    id: 5,
    title: "Product Demo Videos",
    category: "Video & Content Editing",
    image: "https://images.pexels.com/photos/11329815/pexels-photo-11329815.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description: "Engaging product demos for e-commerce store"
  },
  {
    id: 6,
    title: "Influencer Content",
    category: "UGC Production",
    image: "https://images.unsplash.com/photo-1502810190503-8303352d0dd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxjcmVhdGl2ZSUyMHdvcmtzcGFjZXxlbnwwfHx8fDE3NzU2NTQ0MTF8MA&ixlib=rb-4.1.0&q=85",
    description: "Authentic influencer content for brand awareness"
  },
  {
    id: 7,
    title: "Story Highlights",
    category: "Social Media Content & Ads",
    image: "https://images.unsplash.com/photo-1693159682618-074078ed271e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxjcmVhdGl2ZSUyMHdvcmtzcGFjZXxlbnwwfHx8fDE3NzU2NTQ0MTF8MA&ixlib=rb-4.1.0&q=85",
    description: "Instagram story series with custom graphics"
  },
  {
    id: 8,
    title: "Testimonial Reels",
    category: "Video & Content Editing",
    image: "https://images.pexels.com/photos/29152435/pexels-photo-29152435.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description: "Customer testimonial videos edited for social"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Chen",
    role: "Founder, GlowKit Beauty",
    content: "PHOS Studio transformed our social presence. Our engagement tripled in two months, and our ad ROAS went from 2x to 6x. They just get it.",
    rating: 5
  },
  {
    id: 2,
    name: "Marcus Rodriguez",
    role: "Marketing Director, FitFlow",
    content: "The UGC content they produced felt authentic and drove real conversions. We've made this a permanent part of our marketing stack.",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Watson",
    role: "CEO, Urban Threads",
    content: "Professional, creative, and ridiculously fast. Their editing work looks like we spent 10x what we actually did. Worth every penny.",
    rating: 5
  }
];

// Brand/Client Logos for Carousel
// To add logo images: replace 'logo: null' with 'logo: "https://your-logo-url.com/logo.png"'
// Logo images should be PNG or SVG format with transparent backgrounds
// Recommended size: 200-300px width for best display
export const clientBrands = [
  { name: 'Leviathan Group', logo: '/logos/leviathan.jpg' },
  { name: 'King Of Violence', logo: '/logos/king-of-violence.webp' },
  { name: 'Medicbox', logo: '/logos/medicbox.png' },
  { name: 'Jets Pizza', logo: '/logos/jets-pizza.png' },
  { name: 'Kern Auto Sales & Service', logo: '/logos/kern-auto.png' },
  { name: 'Burnbox', logo: '/logos/burnbox.png' },
  { name: 'FD Collectors Club', logo: '/logos/fd-collectors.png' },
  { name: 'Kemp USA', logo: '/logos/kemp-usa.avif' }
];
